<template>
  <div>
    <b-table :dark="dark" :hover="hover" :striped="striped"  :small="small" :fixed="fixed" bordered responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage">
    
      <template v-slot:cell(actions)="row">
        <b-col cols="12" sm="12" md="12" lg="12" class="text-center">
          <a href="#" @click.prevent="createContent(row.item)" class="text-primary"><i class="fa fa-plus fa-lg mt-1"></i></a> &nbsp;
          <a href="#" @click.prevent="editLot(row.item)" class="text-primary"><i class="fa fa-pencil fa-lg mt-1"></i></a> &nbsp;
          <a href="#" @click.prevent="deleteRow(row.item.id)" class="text-danger"><i class="fa fa-trash fa-lg mt-1 " style="color:red"></i></a>
        </b-col>

      </template>

      <template slot="row-details" slot-scope="row">

        <ul  >
          <li v-for="(item, index) in row.item.content_set">
            #<b>{{ item.pallet_number }}</b> ///
            {{item.container_name}} {{item.string_specs}} (<b>{{item.quantity}}</b> Un) ///
            <b>{{item.gross_kilograms}}</b> Kg Brutos ///
            <b>{{item.net_kilograms}}</b> Kg Netos -
            <a href="#" @click.prevent="editContent(item)" class="text-primary">Editar</a> |
              <a href="#" @click.prevent="printContent(item)" class="text-primary">Imprimir</a> |
              <a href="#" @click.prevent="deleteContent(item)" class="text-danger">Eliminar</a>
          </li>
        </ul>

      </template>
      <template v-slot:cell(pallets)="row">
        <div class="text-center font-weight-bold">
          <b-badge pill href="#" @click.prevent="row.toggleDetails" variant="primary">{{row.item.content_set.length}}</b-badge>
        </div>
      </template>



        <template slot="status_content" style="text-align: center"  slot-scope="row">
          
     

            <b-badge variant="info" v-if="row.item.status_content == 1">Sin Procesar </b-badge>
            <b-badge variant="success" v-if="row.item.status_content == 0">Procesado </b-badge>
            
          
          </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons></b-pagination>
      <i-modal :infoModal="infoModal" :contentInfo="contentInfo" @closeModal="infoModal = $event" ref="iModal"></i-modal>
    </nav>

    
<printContent ref="printContent" ></printContent>


  </div>
</template>

<script>



import iModal from './DetalleRecepcionInfoModal.vue'
import {bus} from "../../main";
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'
import Vue from "vue";
import printContent from '../printComponent/printContent.vue'



  const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: 'c-table',
  inheritAttrs: false,
  components: {
    iModal,
    printContent,
  },
  props: {
    waybillID: {
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => ['pallet_number', 'product_name', 'product_type_name',
        'variety_name', 'condition', 'container.name',
        'string_specs', 'quantity', 'net_kilograms','status_content', 'actions','show_details']
    },
    perPage: {
      type: Number,
      default: 15
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      infoModal: false,
      contentInfo: {},
      content_fields: [
        {key: 'pallet_number', label: 'Pallet', sorteable: true},
        {key: 'container_name', label: 'Formato/Recip', sorteable: true},
        {key: 'string_specs', label: 'Especificaciones', sorteable: true},
        {key: 'quantity', label: 'Cantidad', sorteable: true},
        {key: 'gross_kilograms', label: 'Kg Brutos', sorteable: true},
        {key: 'net_kilograms', label: 'Kg Netos', sorteable: true},
        {key: 'actions', label: 'Acciones', sorteable: true},
      ],
    }
  },
  computed: {
    items: function() {
      const items =  this.tableData;
      return Array.isArray(items) ? items : items()
    },
    totalRows: function () { return this.getRowCount() },
    captions: function() { return this.fields }
  },
  methods: {
   
    editLot(data){
      bus.$emit('lotEdit', data);
      },
    editContent(data){
      bus.$emit('editContent', data);
    },
    createContent(data){
      bus.$emit('createContent', data);
    },
    printContent(data){
      this.$refs.printContent.modalShown=true;
      this.$refs.printContent.contentPrint=data;
      },
    showAlert(item) {
      alert(item)
    },
    getBadge (product_type) {
      return product_type === 'Fresco' ? 'success'
        : product_type === 'IQF' ? 'secondary'
          : product_type === 'i' ? 'warning'
            : product_type === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount: function () {
      return this.items.length
    },
    deleteContent(item){
       if(item.status_content==true)
       {
          const Data = {
            id_content: item.id,
            id_pallet: item.pallet,
            client: this.$store.getters.user.ID_CLIENTE,
            tipo:1,
          };
      this.$axios.delete ('/api/v1/content/delete_content/',{ data: Data })
        .then(res => {
          const data = res.data.data;
          miniToastr.success("Operación realizada con éxito", "");
          this.$emit('refreshContent', this.waybillID)
        })
        .catch(error => console.log(error))
        }
        if(item.status_content==false){
           miniToastr.info("Imposible eliminar, contenido procesado !!", "");
        }
    },
    deleteRow(item){

      this.$axios.delete ('/api/v1/lot/'+item+'/')
        .then(res => {
          const data = res.data.data;
          miniToastr.success("Operación realizada con éxito", "");
          this.$emit('refreshContent', this.waybillID)
        })
        .catch(error => console.log(error))
    },
  
  }
}
</script>

<style scoped>
.content_table_styles  {
  color: red;
  border-bottom: 1px solid grey!;
  border-top: 1px solid #cccccc;
}
</style>
